import moment from 'moment';
import React from 'react';
import { Box } from '@mui/material';
import { getMicroExperienceBookingsListForCustomer } from '../../../Services/Microexperiences';
import { DataGridPro } from '@mui/x-data-grid-pro';

export default function MicroExperienceList({ customerId, onSelectMX }) {
    const [mxList, setMXList] = React.useState([]);
    React.useEffect(() => {
        async function getData() {
            const data = (await getMicroExperienceBookingsListForCustomer(customerId)) || [];
            const mxList = data.map((mx) => {
                return {
                    ...mx,
                };
            });
            setMXList(mxList);
        }
        getData();
    }, [customerId]);

    const getRowDate = (bookingDate) => {
        return bookingDate ? moment(bookingDate).format('DD MMM YYYY') : '';
    };

    function selectRow(row) {
        onSelectMX(row.row);
    }

    const columns = [
        {
            field: 'microexperience_name',
            headerName: 'Title',
            width: 200,
            editable: false,
        },
        {
            field: 'microexperience_id',
            headerName: 'ID',
            width: 200,
            editable: false,
        },
        {
            field: 'scheduled_date',
            headerName: 'Scheduled Date',
            valueFormatter: (params) => getRowDate(params.value || ''),
            valueGetter: (params) => {
                return params.value ? moment(params.value) : '';
            },
            width: 120,
        },
        {
            field: 'first_started_at',
            headerName: 'Start Date',
            valueFormatter: (params) => getRowDate(params.value || ''),
            valueGetter: (params) => {
                return params.value ? moment(params.value) : '';
            },
            width: 120,
        },
        {
            field: 'most_recent_started_at',
            headerName: 'Latest Access Date',
            valueFormatter: (params) => getRowDate(params.value || ''),
            valueGetter: (params) => {
                return params.value ? moment(params.value) : '';
            },
            width: 120,
        },
        {
            field: 'microexperience_type',
            headerName: 'Type',
            width: 150,
            editable: false,
        },
        {
            field: 'first_previewed_at',
            headerName: 'Preview Date',
            valueFormatter: (params) => getRowDate(params.value || ''),
            valueGetter: (params) => {
                return params.value ? moment(params.value) : '';
            },
            width: 120,
        },
        {
            field: 'most_recent_previewed_at',
            headerName: 'Latest Preview Date',
            valueFormatter: (params) => getRowDate(params.value || ''),
            valueGetter: (params) => {
                return params.value ? moment(params.value) : '';
            },
            width: 120,
        }
    ];

    return (
        <Box sx={{ flex: 1 }}>
            <DataGridPro
                rows={[...mxList].sort((a, b) => (b.created_on > a.created_on ? 1 : -1))}
                columns={columns}
                pagination={true}
                pageSize={10}
                onRowClick={selectRow}
                sx={{
                    '.MuiDataGrid-columnHeaders': {
                        fontWeight: 'bold',
                        fontSize: 14,
                        color: 'rgb(0,0,0)',
                        backgroundColor: 'rgb(244,246,248)',
                    },
                    '.MuiTablePagination-selectLabel': {
                        marginBottom: '0px',
                    },
                    '.MuiTablePagination-displayedRows': {
                        marginBottom: '0px',
                    },
                    '.MuiPaper-root.div.span': {
                        color: 'blue',
                    },
                    '.MuiDataGrid-main': {
                        height: '576px',
                    },
                }}
            />
        </Box>
    );
}
